import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fv-row mb-7" }
const _hoisted_2 = { class: "required fs-6 fw-semobold mb-2" }
const _hoisted_3 = { class: "fv-row mb-7" }
const _hoisted_4 = { class: "required fs-6 fw-semobold mb-2" }
const _hoisted_5 = { class: "fv-row mb-7" }
const _hoisted_6 = { class: "required fs-6 fw-semobold mb-2" }
const _hoisted_7 = { class: "fv-row mb-7" }
const _hoisted_8 = { class: "required fs-6 fw-semobold mb-2" }

import { ref, inject } from "vue";
import ModelForm from "@/components/ModelForm.vue";
import ErrorMsg from "@/components/ErrorMsg";
import i18n from "@/core/plugins/i18n";
import { ElFormItem, ElInput } from "element-plus";
import { apiProviderKey } from "@/core/plugins/providerKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCreate',
  emits: ["created"],
  setup(__props, { expose: __expose, emit }) {

const api = inject(apiProviderKey);

const refUserCreateModel = ref(null);
const isLoading = ref(true);
const submited = ref(true);



const formData = ref({
  name: "",
  email: "",
  lang: "",
  timezone: "",
});

const rules = ref({
  name: [
    {
      required: true,
      message: i18n.global.t("user.name_require"),
      trigger: "change",
    },
  ],
  email: [
    {
      required: true,
      message: i18n.global.t("user.email_require"),
      trigger: "change",
    },
  ],
  lang: [
    {
      required: true,
      message: i18n.global.t("user.lang_require"),
      trigger: "change",
    },
  ],
  timezone: [
    {
      required: true,
      message: i18n.global.t("user.tz_require"),
      trigger: "change",
    },
  ],
});

const submit = async () => {
  console.log(formData);
  isLoading.value = submited.value = true;

  await api["user.create"]({
    data: {
      name: formData.value.name,
      email: formData.value.email,
      lang: formData.value.lang,
      timezone: formData.value.timezone,
    },
  })
    .then(({ data }) => {
      isLoading.value = submited.value = false;
      emit("created", data.data);
      refUserCreateModel.value.hide();
    })
    .catch(({ response }) => {
      console.log(response);
      ErrorMsg.show(response);
      isLoading.value = submited.value = false;
    });
};

const show = () => {
  refUserCreateModel.value.show();
  isLoading.value = false;
  submited.value = false;
};

const close = () => {
  console.log("close");
};

const resetForm = () => {
  formData.value = {
    name: "",
    email: "",
    lang: "",
    timezone: "",
  };
  isLoading.value = false;
  submited.value = false;
};

__expose({
  resetForm,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModelForm, {
    submit: submit,
    discard: close,
    title: _ctx.$t('action.create'),
    elId: "userCreate",
    isLoading: isLoading.value,
    submited: submited.value,
    savingTitle: _ctx.$t('action.saving'),
    ref_key: "refUserCreateModel",
    ref: refUserCreateModel,
    rules: rules.value,
    formData: formData.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("fields.fullName")), 1),
          _createVNode(_unref(ElFormItem), { prop: "name" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                name: "user_name",
                type: "text",
                placeholder: _ctx.$t('fields.fullName')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("title.email")), 1),
          _createVNode(_unref(ElFormItem), { prop: "email" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: formData.value.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                name: "user_email",
                type: "text",
                placeholder: "example@domain.com"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("fields.language")), 1),
          _createVNode(_unref(ElFormItem), { prop: "lang" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: formData.value.lang,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.lang) = $event)),
                name: "user_language",
                type: "text",
                placeholder: "en"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("fields.timezone")), 1),
          _createVNode(_unref(ElFormItem), { prop: "timezone" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: formData.value.timezone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.timezone) = $event)),
                name: "user_timezone",
                type: "text",
                placeholder: "Sydney/Australia"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isLoading", "submited", "savingTitle", "rules", "formData"]))
}
}

})